import { combineReducers } from "redux"

import { default as forAgency } from "./for-agency"
import { default as forEndCustomer } from "./for-end-customer"

export default combineReducers({ forAgency, forEndCustomer })
